import "slick-carousel/slick/slick.css";
import React, { useState } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import loveIllustrationImageSrc from "images/love-illustration.svg";
import { ReactComponent as ArrowLeftIcon } from "images/arrow-left-3-icon.svg";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right-3-icon.svg";
import i18n from "helpers/i18n";

const Row = tw.div`flex flex-col md:flex-row justify-between items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 xl:w-6/12 flex-shrink-0 relative`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 xl:w-6/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:pr-12 lg:pr-16 md:order-first`
    : tw`md:pl-12 lg:pl-16 md:order-last`,
]);

const Image = styled.img((props) => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
]);

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-6 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const UseCaseSlider = styled(Slider)`
    ${tw`w-full mt-10 text-center md:text-left`}
    .slick-track {
        ${tw`flex`}
    }
    .slick-slide {
        ${tw`h-auto flex justify-center mb-1`}
    }
`;

const UseCase = tw.div`outline-none h-full flex! flex-col`;
const UseCaseHeading = tw.h3`mt-4 text-xl font-bold`;
const UseCaseDescription = tw.p`mt-4 mb-8 sm:mb-10 leading-relaxed font-medium text-gray-700`;
const UseCaseInfoAndControlsContainer = tw.div`mt-auto flex justify-between items-center flex-col sm:flex-row`;
const UseCaseCategory = tw.p`font-medium text-primary-500`;

const Controls = styled.div`
    ${tw`flex mt-8 sm:mt-0`}
    .divider {
        ${tw`my-3 border-r`}
    }
`;
const ControlButton = styled.button`
    ${tw`mx-3 p-4 rounded-full transition duration-300 bg-gray-200 hover:bg-gray-300 text-primary-500 hover:text-primary-700 focus:outline-none focus:shadow-outline`}
    svg {
        ${tw`w-4 h-4 stroke-3`}
    }
`;

export default ({
  imageSrc = loveIllustrationImageSrc,
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  subheading = i18n.t("Tình huống sử dụng"),
  heading = i18n.t("Gợi ý cách dùng Re:Marketing"),
  description = i18n.t("Các tình huống minh họa giúp bạn chọn cách sử dụng phù hợp. Đây không phải đánh giá của khách hàng hay cam kết tăng doanh thu."),
  textOnLeft = false,
  useCases = [
    {
      heading: i18n.t("Chăm sóc lại cuộc trò chuyện"),
      description: i18n.t("Lọc những người đã tương tác với Page, kiểm tra danh sách và chuẩn bị nội dung phù hợp trước khi gửi lại tin nhắn."),
      category: i18n.t("Kênh Facebook"),
    },
    {
      heading: i18n.t("Làm việc với tệp Pancake"),
      description: i18n.t("Chọn Page và lọc cuộc trò chuyện trong Pancake để tổ chức một chiến dịch chăm sóc khách hàng theo nhu cầu của bạn."),
      category: i18n.t("Kênh Pancake"),
    },
    {
      heading: i18n.t("Theo dõi và điều chỉnh chiến dịch"),
      description: i18n.t("Xem kết quả gửi thành công hoặc lỗi, tải danh sách kết quả và điều chỉnh nội dung cho những lần gửi tiếp theo."),
      category: i18n.t("Kết quả gửi tin"),
    },
  ],
}) => {
  const [sliderRef, setSliderRef] = useState(null);

  return (
    <Container>
      <ContentWithPaddingXl>
        <Row>
          <ImageColumn>
            <Image
              src={imageSrc}
              alt=""
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
            />
          </ImageColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <Subheading>{subheading}</Subheading>
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            <UseCaseSlider arrows={false} ref={setSliderRef}>
              {useCases.map((useCase, index) => (
                <UseCase key={index}>
                  <UseCaseHeading>{useCase.heading}</UseCaseHeading>
                  <UseCaseDescription>{useCase.description}</UseCaseDescription>
                  <UseCaseInfoAndControlsContainer>
                    <UseCaseCategory>{useCase.category}</UseCaseCategory>
                    <Controls>
                      <ControlButton
                        aria-label={i18n.t("Tình huống trước")}
                        onClick={sliderRef?.slickPrev}
                      >
                        <ArrowLeftIcon />
                      </ControlButton>
                      <div className="divider" />
                      <ControlButton
                        aria-label={i18n.t("Tình huống tiếp theo")}
                        onClick={sliderRef?.slickNext}
                      >
                        <ArrowRightIcon />
                      </ControlButton>
                    </Controls>
                  </UseCaseInfoAndControlsContainer>
                </UseCase>
              ))}
            </UseCaseSlider>
          </TextColumn>
        </Row>
      </ContentWithPaddingXl>
    </Container>
  );
};
